export default __webpack_public_path__ + "static/SRUS SBDS - Product Specifications & Technical Data-9a0e328f8764565471112551836a7166.pdf";